import { render, staticRenderFns } from "./memberRecord.vue?vue&type=template&id=6865e508"
import script from "./memberRecord.vue?vue&type=script&lang=js"
export * from "./memberRecord.vue?vue&type=script&lang=js"
import style0 from "./memberRecord.vue?vue&type=style&index=0&id=6865e508&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports